window.$ = window.jQuery = require('jquery');
window.cardValidator = require('card-validator');
require('./vendor/jquery/jquery.numberPicker');
require('./vendor/jquery/jquery.limit');
require('bootstrap-sass');
require('jquery-mask-plugin');
require('qtip2');
require('jquery-validation');
require('owl.carousel');
require('./vendor/cropbox/cropbox.min');
require('./vendor/bootstrap-switch/dist/js/bootstrap-switch.min.js');
// require('./vendor/moip/moip');